import SecondHeader from "../Layout/SecondHeader";
import SecondFooter from "../Layout/SecondFooter";
import React, { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export default function Insurance() {
  const [formData, setFormData] = useState({
    name: "",
    contactPerson: "",
    email: "",
    webpage: "",
    phone: "",
    description: "",
  });
  const [errors, setErrors] = useState({});
  const [disable, setDisable] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    setErrors(validationErrors)
    if (Object.keys(validationErrors).length === 0) {
      console.log(formData);
      setDisable(true);
      const response = await fetch('/api/Insurance/Create', {
        method: 'POST',
        body: JSON.stringify(formData),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) {
        console.log(formData);
        toast.error('Error While Submitting the Application. Recheck your Information or Contact Custom Support!');
        setDisable(false);
      } else {
        // Handle success
        toast.success('Application Submitted Successfully! Our Team will contact you ASAP!')
        setFormData({
          name: "",
          contactPerson: "",
          email: "",
          webpage: "",
          phone: "",
          description: "",
        });
      }
      setTimeout(() => {
        setDisable(false);
      }, 3000);
    }
    else {
      setErrors(validationErrors);
    }
  };
  const validateForm = () => {
    let validationErrors = {};
    if (formData.name.trim() === "") {
      validationErrors.name = "Hospital name is required";
    }
    if (formData.contactPerson.trim() === "") {
      validationErrors.contactPerson = "Number ofRepresentative is required";
    }
    if (formData.email.trim() === "") {
      validationErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      validationErrors.email = "Invalid email format";
    }
    if (formData.phone.trim() === "") {
      validationErrors.phone = "Phone is required";
    }
    if (formData.description.trim() === "") {
      validationErrors.description = "Description is required";
    }
    return validationErrors;
  };

  const isValidEmail = (email) => {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <>
      <SecondHeader />
      <ToastContainer />
      <section className="hospital">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3 className="mb-3 mt-2">
                Insurance companies can save millions by using Cancer
                Management.
              </h3>
              <ul className="m-0 mb-4">
                <li>Faster recovery saves time and money.</li>
                <li>Lower cost on tests and treatments.</li>
                <li>Happier clients and higher survival chances.</li>
              </ul>
              <p className="mb-5">
                We have identified that the most effective approach entails a harmonious combination where treatment commences at Cancer Management and works in collaborative partnership with hospitals. Leveraging our adept management skills, we
                aim to provide invaluable support throughout the entire process, aiding doctors, nurses, and patients in making well-informed decisions. Our comprehensive healthcare system further ensures the availability of critical real-time feedback to
                facilitate optimal outcomes.
              </p>

              <h3 className="mb-3 mt-2">
                An exclusive program for insurance companies
              </h3>
              <p >
                We work under the <b>No Cure – No Pay</b> principle with insurance companies.
                This is possible because of the knowledge and experience we have, together
                with use of modern technology and all the tools available for creating a well
                functional healing process for most people. And with Hospital partnerships
                globally, we are confident that we can provide the best possible treatment.
              </p>
              <p>
                These promises are based on the person living more than 5 years after being
                diagnosed with cancer (definition of a cured person or that the person can live
                with the cancer for the rest of his/her life).
              </p>
              <p >
                This No Cure – No Pay agreements must be paid in advance. If for any reason
                the person did die from cancer before 5 years has gone, the fee will be
                returned to the insurance company (or the family).
              </p>
              <p >
                This exclusive program has the same fee no matter the type of cancer.
                $50 000. The fee includes travel, all treatments, a monthly follow-up for the
                first 12 months, and then a follow-up every 6 months. If there are signs of
                cancer recurrence, treatments will be provided for no extra cost.
              </p>
              <h3 className="mb-3 text-center">
                You can apply for a partnership as a representative of an insurance company.
              </h3>
              <div className="text-center">
                <a
                  href="#formInds"
                  style={{ width: "30%" }}
                  class="btn mb-4 custom-button btn-primary"
                >
                  Apply here for partnership
                </a>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <h3 className="mb-3">
                Typical situations where a patient with a cancer diagnosis use
                Cancer Management
              </h3>
              <ul className="m-0 mb-4">
                <li>
                  When oncologists recommend avoiding chemotherapy because a
                  patient’s body is too weak for chemotherapy or radiation.
                </li>
                <li>
                  When chemotherapy or radiation do not provide any results for
                  the patient.
                </li>
                <li>
                  When patients refuse chemotherapy but still need treatments.
                </li>
                <li>
                  When a patient wants natural and modern treatments with no
                  side effects.
                </li>
                <li>
                  When your patients need to recover and regain strength after chemotherapy.
                </li>
              </ul>
              <p className="mb-5">
                We recommend patients embarking upon our program before starting any other
                treatment. This will make patients’ immune systems stronger, give
                them more energy, and overall, a healthier state of body and
                mind. Hence, this helps them survive and recover easier from
                chemotherapy and radiation.
              </p>
              <p>
                The best thing about the Cancer Management program is that patients
                benefit from our program, no matter before, during, or
                after treatments.
              </p>
              <p>
                In certain instances, it is necessary to activate not only the physiological systems but also the mental faculties that contribute to the body's healing process. Our primary focus lies in stimulating the
                activation of individuals' own immune systems and latent healing forces that may not typically be actively engaged.
              </p>
              <h3 class="mb-1">
                Increases chances surviving cancer significant
              </h3>
              <p>
                We believe that by working with the right knowledge and
                modern technology, the chances of surviving cancer can
                increase from under 5% to over 90%.
              </p>
              <p>
                Our first client, a health worker who worked in a hospital for
                more than 30 years, was told she had cancer in more than
                4 inner organs and was given 4 months to live. Her doctors said
                that no method or treatment in the world could save her. She is
                still alive, after more than 20 years. We cannot guarantee
                similar results, But we have evolved and learned much in the
                last 20 years. Today we have more knowledge and better
                technology and tools available. And we will gladly use these to
                serve, teach, and train your patients.
              </p>
              <h3 class="mb-1">
                We recommend starting with a recovery program with
                Cancer Management.
              </h3>
              <p>
                Radiation and chemotherapy sometimes cause severe side effects
                and unnecessary suffering. Use of these methods can damage a patient's nerve
                system, inner organs, digestive system, and immune system.
                Tregrettably, one of the unfortunate consequences observed in many cases is that certain treatments aimed at addressing cancer can inadvertently diminish the chances of survival. A report published in The Lancet, a reputable medical journal, highlighted a concerning fact: over 50% of individuals undergoing chemotherapy treatment
                ultimately succumbed to the adverse effects and toxicity of the treatment itself, rather than the cancer. This underscores the importance of critically evaluating and exploring alternative approaches to cancer management that prioritize both efficacy and minimizing potential harm.
              </p>
              <h3 class="mb-1">New era in cancer treatment</h3>
              <p>
                We firmly believe that it is imperative to prioritize treatments that prioritize the well-being of patients and do not cause harm. This approach aligns with the ethical and moral obligations
                inherent in the medical profession, particularly the principle of "do
                no harm." By adhering to these fundamental principles, we can collectively ensure the highest standard of care and make significant strides in the field of medicine.
              </p>
            </div>
          </div>

          <div className="row my-5" id="formInds">
            <div className="col-lg-8 offset-lg-2">
              <h3 className="mb-5 text-center">
                APPLICATION FOR INSURANCE COMPANIES. <br /> Get the benefits of a
                partnership with Cancer Management.
              </h3>
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <input
                      type="text"
                      className={`form-control ${errors.name ? "is-invalid" : ""
                        }`}
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Insurance Company Name"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-lg-6">
                  <div class="mb-3">
                    <input
                      type="text"
                      className={`form-control ${errors.contactPerson ? "is-invalid" : ""
                        }`}
                      id="contactPerson"
                      name="contactPerson"
                      value={formData.contactPerson}
                      onChange={handleChange}
                      placeholder="Name of representative or contact"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-lg-6">
                  <div class="mb-3">
                    <input
                      type="number"
                      className={`form-control ${errors.phone ? "is-invalid" : ""
                        }`}
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}

                      placeholder="Phone"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-lg-6">
                  <div class="mb-3">
                    <input
                      type="text"
                      className={`form-control ${errors.webpage ? "is-invalid" : ""
                        }`}
                      id="webpage"
                      onChange={handleChange}
                      name="webpage"
                      value={formData.webpage}
                      placeholder="Website"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-lg-6">
                  <div class="mb-3">
                    <input
                      type="text"
                      className={`form-control ${errors.email ? "is-invalid" : ""
                        }`}
                      id="email"
                      name="email"
                      onChange={handleChange}
                      value={formData.email}
                      placeholder="Email"
                    />
                  </div>
                </div>

                <div class="col-12">
                  <div class="mb-3">
                    <textarea
                      className={`form-control ${errors.description ? "is-invalid" : ""
                        }`}
                      id="description"
                      onChange={handleChange}
                      name="description"
                      value={formData.description}
                      placeholder="Tell us about your interest in becoming a partner with Cancer Management, and how many patients
                      you think might be interested in either one of our programs."
                      rows="6"
                    ></textarea>
                  </div>
                </div>
                <div class="col-12 text-center">
                  <button type="button" disabled={disable} onClick={(e) => { handleSubmit(e) }} class="btn custom-button btn-primary">
                    Send Application
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SecondFooter />
    </>
  );
}
